import { Action } from 'redux';
import { DriverAccountCurrentType } from './reducer';

// --- Driver Account ---
export const GET_DRIVER_ACCOUNT = 'driver-accounts/GET_DRIVER_ACCOUNT';
export interface GetDriverAccountAction extends Action<typeof GET_DRIVER_ACCOUNT> {
  readonly payload: number;
}

export const getDriverAccount = (id: number): GetDriverAccountAction => ({
  payload: id,
  type: GET_DRIVER_ACCOUNT,
});

export const getDriverAccountTest = (id: number): GetDriverAccountAction => ({
  payload: id,
  type: GET_DRIVER_ACCOUNT,
});

export const CREATE_DRIVER_ACCOUNT = 'driver-accounts/CREATE_DRIVER_ACCOUNT';
export interface CreateDriverAccountAction extends Action<typeof CREATE_DRIVER_ACCOUNT>, OnCompleteAction {
  readonly payload: DriverAccount;
}

export const SET_DRIVER_ACCOUNT = 'driver-accounts/SET_DRIVER_ACCOUNT';
export interface SetDriverAccountAction extends Action<typeof SET_DRIVER_ACCOUNT> {
  readonly payload: number;
}

export const setDriverAccount = (id: any): SetDriverAccountAction => ({
  payload: id,
  type: SET_DRIVER_ACCOUNT,
});

export const createDriverAccount = (driver: DriverAccount, onComplete?: () => void): CreateDriverAccountAction => ({
  meta: {
    onComplete,
  },
  payload: driver,
  type: CREATE_DRIVER_ACCOUNT,
});

export const UPDATE_DRIVER_ACCOUNT = 'driver-accounts/UPDATE_DRIVER_ACCOUNT';
export interface UpdateDriverAccountAction extends Action<typeof UPDATE_DRIVER_ACCOUNT>, OnCompleteAction {
  readonly payload: DriverAccount;
}

export const updateDriverAccount = (driver: DriverAccount, onComplete?: () => void): UpdateDriverAccountAction => ({
  meta: {
    onComplete,
  },
  payload: driver,
  type: UPDATE_DRIVER_ACCOUNT,
});

export const DELETE_DRIVER_ACCOUNT = 'driver-accounts/DELETE_DRIVER_ACCOUNT';
export interface DeleteDriverAccountAction extends Action<typeof DELETE_DRIVER_ACCOUNT>, OnCompleteAction {
  readonly payload: DriverAccount;
}

export const deleteDriverAccount = (driver: DriverAccount, onComplete?: () => void): DeleteDriverAccountAction => ({
  meta: {
    onComplete,
  },
  payload: driver,
  type: DELETE_DRIVER_ACCOUNT,
});

export const GET_DRIVER_REGISTER_LAYOUT_IMAGES_STATE = 'driver-page-layout/GET_DRIVER_REGISTER_LAYOUT_IMAGES_STATE';
export const SET_DRIVER_REGISTER_LAYOUT_IMAGES_STATE = 'driver-page-layout/SET_DRIVER_REGISTER_LAYOUT_IMAGES_STATE';
// Register Page
export const getDriverRegisterImages = (data: any): GetDriverRegisterImagesAction => ({
  type: GET_DRIVER_REGISTER_LAYOUT_IMAGES_STATE,
  payload: data,
});

export const setDriverRegisterImages = (data: any): SetDriverRegisterImagesAction => ({
  type: SET_DRIVER_REGISTER_LAYOUT_IMAGES_STATE,
  payload: data,
});

export interface GetDriverRegisterImagesAction extends Action<typeof GET_DRIVER_REGISTER_LAYOUT_IMAGES_STATE> {
  readonly payload: any;
}

export interface SetDriverRegisterImagesAction extends Action<typeof SET_DRIVER_REGISTER_LAYOUT_IMAGES_STATE> {
  readonly payload: any;
}

//
// get Register data
export const GET_DRIVER_REGISTER_DATA = 'driver-page-layout/GET_DRIVER_REGISTER_DATA';
export const getDriverRegisterData = (data: any): GetDriverRegisterDataAction => ({
  type: GET_DRIVER_REGISTER_DATA,
  payload: data,
});
export interface GetDriverRegisterDataAction extends Action<typeof GET_DRIVER_REGISTER_DATA> {
  readonly payload: any;
}

export const SET_DRIVER_REGISTER_DATA = 'driver-page-layout/SET_DRIVER_REGISTER_DATA';
export const setDriverRegisterData = (data: any): SetDriverRegisterDataAction => ({
  type: SET_DRIVER_REGISTER_DATA,
  payload: data,
});
export interface SetDriverRegisterDataAction extends Action<typeof SET_DRIVER_REGISTER_DATA> {
  readonly payload: any;
}

// --- Current ---
export const PERSIST_DRIVER_ACCOUNT_CURRENT = 'driver-accounts/PERSIST_DRIVER_ACCOUNT_CURRENT';
export interface PersistDriverAccountCurrent extends Action<typeof PERSIST_DRIVER_ACCOUNT_CURRENT> {
  readonly payload: {
    readonly type: DriverAccountCurrentType;
    readonly data: DriverAccount | EmailAddress | Address | Phone | Vehicle;
    readonly etag?: string;
  };
}

export interface PersistDriverAccountAction extends Action<typeof PERSIST_DRIVER_ACCOUNT_CURRENT> {
  readonly payload: {
    readonly type: 'driver';
    readonly data: DriverAccount;
    readonly etag?: string;
  };
}

export const persistDriverAccount = (driver: DriverAccount, etag?: string): PersistDriverAccountAction => ({
  payload: {
    data: driver,
    etag,
    type: 'driver',
  },
  type: PERSIST_DRIVER_ACCOUNT_CURRENT,
});

export interface PersistDriverAccountEmailAction extends Action<typeof PERSIST_DRIVER_ACCOUNT_CURRENT> {
  readonly payload: {
    readonly type: 'email';
    readonly data: EmailAddress;
    readonly etag?: string;
  };
}

export const persistDriverAccountEmail = (email: EmailAddress, etag?: string): PersistDriverAccountEmailAction => ({
  payload: {
    data: email,
    etag,
    type: 'email',
  },
  type: PERSIST_DRIVER_ACCOUNT_CURRENT,
});

export interface PersistDriverAccountPhoneAction extends Action<typeof PERSIST_DRIVER_ACCOUNT_CURRENT> {
  readonly payload: {
    readonly type: 'phone';
    readonly data: Phone;
    readonly etag?: string;
  };
}

export const persistDriverAccountPhone = (phone: Phone, etag?: string): PersistDriverAccountPhoneAction => ({
  payload: {
    data: phone,
    etag,
    type: 'phone',
  },
  type: PERSIST_DRIVER_ACCOUNT_CURRENT,
});

export interface PersistDriverAccountAddressAction extends Action<typeof PERSIST_DRIVER_ACCOUNT_CURRENT> {
  readonly payload: {
    readonly type: 'address';
    readonly data: Address;
    readonly etag?: string;
  };
}

export const persistDriverAccountAddress = (data: Address, etag?: string): PersistDriverAccountAddressAction => ({
  payload: {
    data,
    etag,
    type: 'address',
  },
  type: PERSIST_DRIVER_ACCOUNT_CURRENT,
});

export interface PersistDriverAccountVehicleAction extends Action<typeof PERSIST_DRIVER_ACCOUNT_CURRENT> {
  readonly payload: {
    readonly type: 'vehicle';
    readonly data: Vehicle;
    readonly etag?: string;
  };
}

export const persistDriverAccountVehicle = (vehicle: Vehicle, etag?: string): PersistDriverAccountVehicleAction => ({
  payload: {
    data: vehicle,
    etag,
    type: 'vehicle',
  },
  type: PERSIST_DRIVER_ACCOUNT_CURRENT,
});

export const RESET_DRIVER_ACCOUNT_CURRENT = 'driver-accounts/RESET_DRIVER_ACCOUNT_CURRENT';
export interface ResetDriverAccountCurrent extends Action<typeof RESET_DRIVER_ACCOUNT_CURRENT> {
  readonly payload: DriverAccountCurrentType;
}

export const resetDriverAccountCurrent = (type: DriverAccountCurrentType): ResetDriverAccountCurrent => ({
  payload: type,
  type: RESET_DRIVER_ACCOUNT_CURRENT,
});

//
// --- Driver Account Email ---
export const GET_DRIVER_ACCOUNT_EMAIL = 'driver-accounts/GET_DRIVER_ACCOUNT_EMAIL';
export interface GetDriverAccountEmailAction extends Action<typeof GET_DRIVER_ACCOUNT_EMAIL> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly email: number;
  };
}

export const getDriverAccountEmail = (driver: DriverAccount, id: number): GetDriverAccountEmailAction => ({
  payload: { driver, email: id },
  type: GET_DRIVER_ACCOUNT_EMAIL,
});

export const CREATE_DRIVER_ACCOUNT_EMAIL = 'driver-accounts/CREATE_DRIVER_ACCOUNT_EMAIL';
export interface CreateDriverAccountEmailAction extends Action<typeof CREATE_DRIVER_ACCOUNT_EMAIL> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly email: EmailAddress;
  };
}

export const createDriverAccountEmail = (
  driver: DriverAccount,
  email: EmailAddress,
): CreateDriverAccountEmailAction => ({
  payload: { driver, email },
  type: CREATE_DRIVER_ACCOUNT_EMAIL,
});

export const UPDATE_DRIVER_ACCOUNT_EMAIL = 'driver-accounts/UPDATE_DRIVER_ACCOUNT_EMAIL';
export interface UpdateDriverAccountEmailAction extends Action<typeof UPDATE_DRIVER_ACCOUNT_EMAIL> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly email: EmailAddress;
  };
}

export const updateDriverAccountEmail = (
  driver: DriverAccount,
  email: EmailAddress,
): UpdateDriverAccountEmailAction => ({
  payload: { driver, email },
  type: UPDATE_DRIVER_ACCOUNT_EMAIL,
});

export const DELETE_DRIVER_ACCOUNT_EMAIL = 'driver-accounts/DELETE_DRIVER_ACCOUNT_EMAIL';
export interface DeleteDriverAccountEmailAction extends Action<typeof DELETE_DRIVER_ACCOUNT_EMAIL> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly email: EmailAddress;
  };
}

export const deleteDriverAccountEmail = (
  driver: DriverAccount,
  email: EmailAddress,
): DeleteDriverAccountEmailAction => ({
  payload: {
    driver,
    email,
  },
  type: DELETE_DRIVER_ACCOUNT_EMAIL,
});

//
// --- Driver Account Phone ---
export const GET_DRIVER_ACCOUNT_PHONE = 'driver-accounts/GET_DRIVER_ACCOUNT_PHONE';
export interface GetDriverAccountPhoneAction extends Action<typeof GET_DRIVER_ACCOUNT_PHONE> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly phone: number;
  };
}

export const getDriverAccountPhone = (driver: DriverAccount, id: number): GetDriverAccountPhoneAction => ({
  payload: {
    driver,
    phone: id,
  },
  type: GET_DRIVER_ACCOUNT_PHONE,
});

export const CREATE_DRIVER_ACCOUNT_PHONE = 'driver-accounts/CREATE_DRIVER_ACCOUNT_PHONE';
export interface CreateDriverAccountPhoneAction extends Action<typeof CREATE_DRIVER_ACCOUNT_PHONE> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly phone: Phone;
  };
}

export const createDriverAccountPhone = (driver: DriverAccount, phone: Phone): CreateDriverAccountPhoneAction => ({
  payload: {
    driver,
    phone,
  },
  type: CREATE_DRIVER_ACCOUNT_PHONE,
});

export const UPDATE_DRIVER_ACCOUNT_PHONE = 'driver-accounts/UPDATE_DRIVER_ACCOUNT_PHONE';
export interface UpdateDriverAccountPhoneAction extends Action<typeof UPDATE_DRIVER_ACCOUNT_PHONE> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly phone: Phone;
  };
}

export const updateDriverAccountPhone = (driver: DriverAccount, phone: Phone): UpdateDriverAccountPhoneAction => ({
  payload: {
    driver,
    phone,
  },
  type: UPDATE_DRIVER_ACCOUNT_PHONE,
});

export const DELETE_DRIVER_ACCOUNT_PHONE = 'driver-accounts/DELETE_DRIVER_ACCOUNT_PHONE';
export interface DeleteDriverAccountPhoneAction extends Action<typeof DELETE_DRIVER_ACCOUNT_PHONE> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly phone: Phone;
  };
}

export const deleteDriverAccountPhone = (driver: DriverAccount, phone: Phone): DeleteDriverAccountPhoneAction => ({
  payload: {
    driver,
    phone,
  },
  type: DELETE_DRIVER_ACCOUNT_PHONE,
});

//
// --- Driver Account Address ---
export const GET_DRIVER_ACCOUNT_ADDRESS = 'driver-accounts/GET_DRIVER_ACCOUNT_ADDRESS';
export interface GetDriverAccountAddressAction extends Action<typeof GET_DRIVER_ACCOUNT_ADDRESS> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly address: number;
  };
}

export const getDriverAccountAddress = (driver: DriverAccount, id: number): GetDriverAccountAddressAction => ({
  payload: { address: id, driver },
  type: GET_DRIVER_ACCOUNT_ADDRESS,
});

export const CREATE_DRIVER_ACCOUNT_ADDRESS = 'driver-accounts/CREATE_DRIVER_ACCOUNT_ADDRESS';
export interface CreateDriverAccountAddressAction extends Action<typeof CREATE_DRIVER_ACCOUNT_ADDRESS> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly address: Address;
  };
}

export const createDriverAccountAddress = (
  driver: DriverAccount,
  address: Address,
): CreateDriverAccountAddressAction => ({
  payload: { address, driver },
  type: CREATE_DRIVER_ACCOUNT_ADDRESS,
});

export const UPDATE_DRIVER_ACCOUNT_ADDRESS = 'driver-accounts/UPDATE_DRIVER_ACCOUNT_ADDRESS';
export interface UpdateDriverAccountAddressAction extends Action<typeof UPDATE_DRIVER_ACCOUNT_ADDRESS> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly address: Address;
  };
}

export const updateDriverAccountAddress = (
  driver: DriverAccount,
  address: Address,
): UpdateDriverAccountAddressAction => ({
  payload: { address, driver },
  type: UPDATE_DRIVER_ACCOUNT_ADDRESS,
});

export const DELETE_DRIVER_ACCOUNT_ADDRESS = 'driver-accounts/DELETE_DRIVER_ACCOUNT_ADDRESS';
export interface DeleteDriverAccountAddressAction extends Action<typeof DELETE_DRIVER_ACCOUNT_ADDRESS> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly address: Address;
  };
}

export const deleteDriverAccountAddress = (
  driver: DriverAccount,
  address: Address,
): DeleteDriverAccountAddressAction => ({
  payload: { address, driver },
  type: DELETE_DRIVER_ACCOUNT_ADDRESS,
});

//
// --- Driver Account Vehicle ---
export const GET_DRIVER_ACCOUNT_VEHICLE = 'driver-accounts/GET_DRIVER_ACCOUNT_VEHICLE';
export interface GetDriverAccountVehicleAction extends Action<typeof GET_DRIVER_ACCOUNT_VEHICLE> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly vehicle: number;
  };
}

export const getDriverAccountVehicle = (driver: DriverAccount, id: number): GetDriverAccountVehicleAction => ({
  payload: {
    driver,
    vehicle: id,
  },
  type: GET_DRIVER_ACCOUNT_VEHICLE,
});

export const CREATE_DRIVER_ACCOUNT_VEHICLE = 'driver-accounts/CREATE_DRIVER_ACCOUNT_VEHICLE';
export interface CreateDriverAccountVehicleAction extends Action<typeof CREATE_DRIVER_ACCOUNT_VEHICLE> {
  payload: {
    driver: DriverAccount;
    vehicle: Vehicle;
  };
}

export const createDriverAccountVehicle = (
  driver: DriverAccount,
  vehicle: Vehicle,
): CreateDriverAccountVehicleAction => ({
  payload: {
    driver,
    vehicle,
  },
  type: CREATE_DRIVER_ACCOUNT_VEHICLE,
});

export const UPDATE_DRIVER_ACCOUNT_VEHICLE = 'driver-accounts/UPDATE_DRIVER_ACCOUNT_VEHICLE';
export interface UpdateDriverAccountVehicleAction extends Action<typeof UPDATE_DRIVER_ACCOUNT_VEHICLE> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly vehicle: Vehicle;
  };
}

export const updateDriverAccountVehicle = (
  driver: DriverAccount,
  vehicle: Vehicle,
): UpdateDriverAccountVehicleAction => ({
  payload: {
    driver,
    vehicle,
  },
  type: UPDATE_DRIVER_ACCOUNT_VEHICLE,
});

export const updateVehicleActivation = (
  driver: DriverAccount,
  vehicle: Vehicle,
  active: boolean,
): UpdateDriverAccountVehicleAction => ({
  payload: {
    driver,
    vehicle: {
      ...vehicle,
      inactive: active,
    },
  },
  type: UPDATE_DRIVER_ACCOUNT_VEHICLE,
});

export const MERGE_DRIVER_ACCOUNT_VEHICLES = 'driver-accounts/MERGE_DRIVER_ACCOUNT_VEHICLE';

export const mergeDriverAccountVehicles = (data: any) => {
  return {
    type: MERGE_DRIVER_ACCOUNT_VEHICLES,
    payload: data,
  };
};

export const DELETE_DRIVER_ACCOUNT_VEHICLE = 'driver-accounts/DELETE_DRIVER_ACCOUNT_VEHICLE';
export interface DeleteDriverAccountVehicleAction extends Action<typeof DELETE_DRIVER_ACCOUNT_VEHICLE> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly vehicle: Vehicle;
  };
}

export const deleteDriverAccountVehicle = (
  driver: DriverAccount,
  vehicle: Vehicle,
): DeleteDriverAccountVehicleAction => ({
  payload: {
    driver,
    vehicle,
  },
  type: DELETE_DRIVER_ACCOUNT_VEHICLE,
});

//
// --- Driver Orders ---
export const GET_DRIVER_ACCOUNT_ORDERS = 'driver-accounts/GET_DRIVER_ACCOUNT_ORDERS';
export interface GetDriverAccountOrdersAction extends Action<typeof GET_DRIVER_ACCOUNT_ORDERS> {
  readonly payload: {
    readonly driverId: number;
  };
}

export const getDriverAccountOrders = (id: number): GetDriverAccountOrdersAction => ({
  payload: { driverId: id },
  type: GET_DRIVER_ACCOUNT_ORDERS,
});

export const GET_DRIVER_ACCOUNT_CITATIONS = 'driver-accounts/GET_DRIVER_ACCOUNT_CITATIONS';
export interface GetDriverAccountCitationsAction extends Action<typeof GET_DRIVER_ACCOUNT_CITATIONS> {
  readonly payload: {
    readonly driverId: number;
  };
}

export const getDriverAccountCitations = (id: number): GetDriverAccountCitationsAction => ({
  payload: { driverId: id },
  type: GET_DRIVER_ACCOUNT_CITATIONS,
});

export interface PersistDriverAccountOrdersAction extends Action<typeof PERSIST_DRIVER_ACCOUNT_CURRENT> {
  readonly payload: {
    readonly type: 'orders';
    readonly data: ReadonlyArray<OrderView>;
    readonly etag: undefined;
  };
}

export const persistDriverAccountOrders = (orders: ReadonlyArray<OrderView>): PersistDriverAccountOrdersAction => ({
  payload: {
    data: orders,
    etag: undefined,
    type: 'orders',
  },
  type: PERSIST_DRIVER_ACCOUNT_CURRENT,
});

export interface PersistDriverAccountCitationsAction extends Action<typeof PERSIST_DRIVER_ACCOUNT_CURRENT> {
  readonly payload: {
    readonly type: 'citations';
    readonly data: ReadonlyArray<CitationView>;
    readonly etag: undefined;
  };
}

export const persistDriverAccountCitations = (
  citations: ReadonlyArray<CitationView>,
): PersistDriverAccountCitationsAction => ({
  payload: {
    data: citations,
    etag: undefined,
    type: 'citations',
  },
  type: PERSIST_DRIVER_ACCOUNT_CURRENT,
});

//
// --- Driver Profile Notes ---
export const GET_DRIVER_ACCOUNT_NOTES = 'driver-accounts/GET_DRIVER_ACCOUNT_NOTES';
export interface GetDriverAccountNotesAction extends Action<typeof GET_DRIVER_ACCOUNT_NOTES> {
  readonly payload: {
    readonly driverId: number;
  };
}

export const getDriverAccountNotes = (id: number): GetDriverAccountNotesAction => ({
  payload: { driverId: id },
  type: GET_DRIVER_ACCOUNT_NOTES,
});

export interface PersistDriverAccountNotesAction extends Action<typeof PERSIST_DRIVER_ACCOUNT_CURRENT> {
  readonly payload: {
    readonly type: 'notes';
    readonly data: ReadonlyArray<Note>;
    readonly etag: undefined;
  };
}

export const persistDriverAccountNotes = (notes: ReadonlyArray<Note>): PersistDriverAccountNotesAction => ({
  payload: {
    data: notes,
    etag: undefined,
    type: 'notes',
  },
  type: PERSIST_DRIVER_ACCOUNT_CURRENT,
});

export const ADD_DRIVER_ACCOUNT_NOTE = 'driver-accounts/ADD_DRIVER_ACCOUNT_NOTE';
export interface AddDriverAccountNoteAction extends Action<typeof ADD_DRIVER_ACCOUNT_NOTE>, OnCompleteAction {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly text: string;
  };
}

export const addDriverAccountNote = (
  driver: DriverAccount,
  text: string,
  onComplete?: () => void,
): AddDriverAccountNoteAction => ({
  meta: {
    onComplete,
  },
  payload: {
    driver,
    text,
  },
  type: ADD_DRIVER_ACCOUNT_NOTE,
});

export const DELETE_DRIVER_ACCOUNT_NOTE = 'driver-accounts/DELETE_DRIVER_ACCOUNT_NOTE';
export interface DeleteDriverAccountNoteAction extends Action<typeof DELETE_DRIVER_ACCOUNT_NOTE>, OnCompleteAction {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly noteId: number;
  };
}

export const deleteDriverAccountNote = (
  driver: DriverAccount,
  noteId: number,
  onComplete?: () => void,
): DeleteDriverAccountNoteAction => ({
  meta: {
    onComplete,
  },
  payload: {
    driver,
    noteId,
  },
  type: DELETE_DRIVER_ACCOUNT_NOTE,
});

//
// --- Driver Attributes ---
export const SAVE_DRIVER_ATTRIBUTE_TO_ACCOUNT = 'driver-accounts/SAVE_DRIVER_ATTRIBUTE_TO_ACCOUNT';
export interface SaveDriverAttributeToAccountAction
  extends Action<typeof SAVE_DRIVER_ATTRIBUTE_TO_ACCOUNT>, OnCompleteAction {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly attributePayload: DriverAttributeToAccountPayload;
  };
}

export const addDriverAttributeToAccount = (
  driver: DriverAccount,
  payload: DriverAttributeToAccountPayload,
  onComplete?: () => void,
): SaveDriverAttributeToAccountAction => ({
  meta: {
    onComplete,
  },
  payload: {
    attributePayload: payload,
    driver,
  },
  type: SAVE_DRIVER_ATTRIBUTE_TO_ACCOUNT,
});

export const UPDATE_DRIVER_ATTRIBUTE_TO_ACCOUNT = 'driver-accounts/UPDATE_DRIVER_ATTRIBUTE_TO_ACCOUNT';
export interface UpdateDriverAttributeToAccount {
  readonly payload: {
    readonly driver: DriverAccount;
  };
}

export const updateDriverAttributeToAccount = () => ({
  type: UPDATE_DRIVER_ATTRIBUTE_TO_ACCOUNT,
});

export const DELETE_DRIVER_ACCOUNT_ATTRIBUTE = 'driver-accounts/DELETE_DRIVER_ACCOUNT_ATTRIBUTE';
export interface DeleteDriverAccountAttributeAction
  extends Action<typeof DELETE_DRIVER_ACCOUNT_ATTRIBUTE>, OnCompleteAction {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly attribute: DriverAccountAttribute;
  };
}

export const deleteDriverAccountAttribute = (
  driver: DriverAccount,
  attribute: DriverAccountAttribute,
  onComplete?: () => void,
): DeleteDriverAccountAttributeAction => ({
  meta: {
    onComplete,
  },
  payload: {
    attribute,
    driver,
  },
  type: DELETE_DRIVER_ACCOUNT_ATTRIBUTE,
});

export const GET_KNOWN_DRIVER_ACCOUNT_ATTRIBUTES = 'driver-accounts/GET_KNOWN_DRIVER_ACCOUNT_ATTRIBUTES';
export interface GetKnownDriverAccountAttributesAction extends Action<typeof GET_KNOWN_DRIVER_ACCOUNT_ATTRIBUTES> {}

export const PERSIST_KNOWN_DRIVER_ACCOUNT_ATTRIBUTES = 'driver-accounts/PERSIST_KNOWN_DRIVER_ACCOUNT_ATTRIBUTES';
export interface PersistKnownDriverAccountAttributesAction extends Action<
  typeof PERSIST_KNOWN_DRIVER_ACCOUNT_ATTRIBUTES
> {
  readonly payload: ReadonlyArray<PersistedDriverAttributeModel>;
}

export const persistKnownDriverAccountAttributes = (
  attributes: ReadonlyArray<PersistedDriverAttributeModel>,
): PersistKnownDriverAccountAttributesAction => ({
  payload: attributes,
  type: PERSIST_KNOWN_DRIVER_ACCOUNT_ATTRIBUTES,
});

//
// --- Driver Account Defaults ---
export const UPDATE_DEFAULT_ADDRESS = 'driver-accounts/UPDATE_DEFAULT_ADDRESS';
export interface UpdateDefaultAddressAction extends Action<typeof UPDATE_DEFAULT_ADDRESS> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly address: Address;
  };
}

export const updateDefaultAddress = (driver: DriverAccount, address: Address): UpdateDefaultAddressAction => ({
  payload: {
    address,
    driver,
  },
  type: UPDATE_DEFAULT_ADDRESS,
});

export const UPDATE_DEFAULT_EMAIL = 'driver-accounts/UPDATE_DEFAULT_EMAIL';
export interface UpdateDefaultEmailAction extends Action<typeof UPDATE_DEFAULT_EMAIL> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly email: EmailAddress;
  };
}

export const updateDefaultEmail = (driver: DriverAccount, email: EmailAddress): UpdateDefaultEmailAction => ({
  payload: {
    driver,
    email,
  },
  type: UPDATE_DEFAULT_EMAIL,
});

export const UPDATE_DEFAULT_PHONE = 'driver-accounts/UPDATE_DEFAULT_PHONE';
export interface UpdateDefaultPhoneAction extends Action<typeof UPDATE_DEFAULT_PHONE> {
  readonly payload: {
    readonly driver: DriverAccount;
    readonly phone: Phone;
  };
}

export const updateDefaultPhone = (driver: DriverAccount, phone: Phone): UpdateDefaultPhoneAction => ({
  payload: {
    driver,
    phone,
  },
  type: UPDATE_DEFAULT_PHONE,
});

export const GET_VEHICLE_DETAILS_BY_VIN = 'driver-accounts/GET_VEHICLE_DETAILS_BY_VIN';
export const getVehicleDetailsByVIN = (data: any) => {
  return {
    type: GET_VEHICLE_DETAILS_BY_VIN,
    payload: data,
  };
};
export const SET_VEHICLE_DETAILS_VIN = 'driver-accounts/SET_VEHICLE_DETAILS_VIN';
export const setVehicleDetailsVin = (data: any) => {
  return {
    type: SET_VEHICLE_DETAILS_VIN,
    payload: data,
  };
};
export interface SetVehicleDetailsVinAction extends Action<typeof SET_VEHICLE_DETAILS_VIN> {
  readonly payload: any;
}
export const RESET_VEHICLE_DETAILS_VIN = 'driver-accounts/RESET_VEHICLE_DETAILS_VIN';
export const resetVehicleDetailsVin = () => {
  return {
    type: RESET_VEHICLE_DETAILS_VIN,
  };
};
export interface ResetVehicleDetailsVinAction extends Action<typeof RESET_VEHICLE_DETAILS_VIN> {}

//////////////for Vehicle onchange Make in Driver Profile /////////////////////

export const IS_SELECT_OTHER_VEHILE_YN = 'driver-accounts/IS_SELECT_OTHER_VEHILE_YN';
export const setSelectedOtherVehicleYN = (data: any) => {
  return {
    type: IS_SELECT_OTHER_VEHILE_YN,
    payload: data,
  };
};
export interface SetIsSelectedOtherVehicle extends Action<typeof IS_SELECT_OTHER_VEHILE_YN> {
  readonly payload: any;
}

// unknow citaiton  open end modal

export const UNKNOWN_CITATION_OPEN_MODAL = 'driver-accounts/UNKNOWN_CITATION_OPEN_MODAL';
export const unknowncitationOpenmodal = () => {
  return {
    type: UNKNOWN_CITATION_OPEN_MODAL,
  };
};
export interface UnknowncitationOpenmodalAction extends Action<typeof UNKNOWN_CITATION_OPEN_MODAL> {}

export const UNKNOWN_CITATION_CLOSE_MODAL = 'driver-accounts/UNKNOWN_CITATION_CLOSE_MODAL';
export const unknowncitationClosemodal = () => {
  return {
    type: UNKNOWN_CITATION_CLOSE_MODAL,
  };
};
export interface UnknowncitationClosemodalAction extends Action<typeof UNKNOWN_CITATION_CLOSE_MODAL> {}
// unknow citaiton  open end modal

////////////// end for Vehicle onchange Make in Driver Profile /////////////////////

export type DriverAccountAction =
  | PersistDriverAccountCurrent
  | ResetDriverAccountCurrent
  | GetDriverAccountAction
  | SetDriverAccountAction
  | CreateDriverAccountAction
  | PersistDriverAccountAction
  | GetDriverAccountEmailAction
  | CreateDriverAccountEmailAction
  | UpdateDriverAccountEmailAction
  | DeleteDriverAccountEmailAction
  | PersistDriverAccountEmailAction
  | GetDriverAccountPhoneAction
  | CreateDriverAccountPhoneAction
  | UpdateDriverAccountPhoneAction
  | DeleteDriverAccountPhoneAction
  | PersistDriverAccountPhoneAction
  | PersistDriverAccountAddressAction
  | PersistDriverAccountVehicleAction
  | GetDriverAccountAddressAction
  | CreateDriverAccountAddressAction
  | UpdateDriverAccountAddressAction
  | DeleteDriverAccountAddressAction
  | GetDriverAccountVehicleAction
  | CreateDriverAccountVehicleAction
  | UpdateDriverAccountVehicleAction
  | DeleteDriverAccountVehicleAction
  | SaveDriverAttributeToAccountAction
  | DeleteDriverAccountAttributeAction
  | GetKnownDriverAccountAttributesAction
  | PersistKnownDriverAccountAttributesAction
  | GetDriverAccountOrdersAction
  | PersistDriverAccountOrdersAction
  | GetDriverAccountNotesAction
  | PersistDriverAccountNotesAction
  | AddDriverAccountNoteAction
  | DeleteDriverAccountNoteAction
  | SetVehicleDetailsVinAction
  | ResetVehicleDetailsVinAction
  | SetIsSelectedOtherVehicle
  | UnknowncitationOpenmodalAction
  | UnknowncitationClosemodalAction
  | GetDriverRegisterImagesAction
  | GetDriverRegisterDataAction
  | SetDriverRegisterDataAction
  | SetDriverRegisterImagesAction;
